export default {
    common: {
        save: 'บันทึก',
        cancel: 'ยกเลิก'
    },
    currency: {
        symbol: 'บาท'
    }
}
